import getArchiveFanoutMailboxInfoForResult from "./getArchiveFanoutMailboxInfoForResult";

export default function isResultFromArchiveFanout(mailboxGuids: string[]): boolean {
    return !!getArchiveFanoutMailboxInfoForResult(mailboxGuids);
}
